import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { NeoDialog } from '@neogov/pattern-library/neo-dialog';
import { BrowserNavigation } from '@shared';
import { AppConfigService } from '../config/app-config.service';
import { EIDCProvider } from '../providers/oidc/eidc.provider';
import { SessionExpiredModalComponent, SessionExpiredModalResult } from '../../presentation/modals/session-expired-modal';
import { resolveHomePath } from './resolve-home-path.util';

@Injectable({
  providedIn: 'root',
})
export class SessionExpiredDialogService {
  private readonly _router = inject(Router);
  private readonly _dialog = inject(NeoDialog);
  private readonly _eidcProvider = inject(EIDCProvider);
  private readonly _configService = inject(AppConfigService);
  private readonly _browserNavigation = inject(BrowserNavigation);

  private readonly _isDialogOpen = signal(false);
  public readonly isDialogOpen = this._isDialogOpen.asReadonly();

  private readonly _wasShown = signal(false);
  public readonly wasShown = this._wasShown.asReadonly();

  private _homePath = '/cases/dashboard';

  public show(): void {
    if (this._isDialogOpen() || this._wasShown()) {
      return;
    }

    this._homePath = resolveHomePath(this._router.url);
    this._isDialogOpen.set(true);
    this._wasShown.set(true);

    const dialogRef = this._dialog.open<SessionExpiredModalComponent, undefined, SessionExpiredModalResult>(
      SessionExpiredModalComponent,
      {
        disableClose: true,
        closeOnNavigation: false,
        hasBackdrop: true,
        width: '600px',
        maxWidth: '600px',
      },
    );

    firstValueFrom(dialogRef.afterClosed())
      .then((result: SessionExpiredModalResult | undefined) => {
        this._isDialogOpen.set(false);

        if (result === 'go-home') {
          this._router.navigate([this._homePath]);
        } else {
          if (!this._configService.isLocal()) {
            this._eidcProvider.signOut();
          } else {
            this._eidcProvider.signOutLocal();
            this._browserNavigation.navigateToUrl(this._configService.loginPath);
          }
        }
      })
      .catch(() => {
        this._isDialogOpen.set(false);
      });
  }

}
